import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ProgramTimeline } from 'features/programs';

const PageProgramTimeline = () => {
  const { programId } = useRequiredParams<{ programId: string }>();

  return (
    <AppLayout>
      <ProgramTimeline programId={programId} />
    </AppLayout>
  );
};

export default PageProgramTimeline;
